import { type SizeFiltersResponse } from '@/modules/filters/aliases';

export function flattenSizeTree(sizeFilters?: SizeFiltersResponse) {
  return sizeFilters?.flatMap((department) =>
    department.children.flatMap((group) => group.children)
  );
}

export function getSizeName(
  sizeFilters?: SizeFiltersResponse,
  variantSet?: number,
  variantId?: number
) {
  if (!sizeFilters || !variantSet || !variantId) {
    return '';
  }

  const flattenedTree = flattenSizeTree(sizeFilters);

  const size = flattenedTree
    ?.find((branch) => branch.id === variantSet)
    ?.children.find((leaf) => leaf.id === variantId);

  return size?.name ?? '';
}

export function getProductSizeName(
  sizes: (string | undefined)[] = [],
  translations: {
    multipleSizes: string;
    size?: string;
  }
) {
  const multipleSizes = sizes.length > 1;

  const name = sizes?.[0];
  const oneSizeRegex = new RegExp(
    'one size|einheitsgröße|taglia unica|taille unique',
    'i'
  );

  if (multipleSizes) {
    return translations.multipleSizes;
  }
  if (name) {
    if (oneSizeRegex.test(name)) {
      return name;
    }
    return translations.size ? `${translations.size} ${name}` : name;
  }
  return '';
}
